import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { CHAT_UNREAD_BADGE_CLASS } from '@/features/Chat';
import type { MenuItem } from '@/shared/types/common';
import { Svg } from '@/shared/ui/Svg';
import { isPathMatching } from '../../lib/utils/navigation';
import styles from '../../ui/Sidebar/Sidebar.module.scss';

export const SimpleMenuItem = ({
  item,
  pathname,
  badgeCount,
}: {
  item: MenuItem;
  pathname: string;
  badgeCount?: number;
}) => {
  const navigate = useNavigate();
  const active = isPathMatching(item.href, pathname);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Use navigation to avoid full page reloads while preserving Link semantics
    event.preventDefault();
    if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <Link
      to={item.href || ''}
      onClick={handleClick}
      className={cn(styles.listBoxItemBase, {
        ['bg-red']: active,
        [styles.active]: active,
      })}
    >
      <div className="flex w-full items-center gap-3">
        {item.icon && (
          <Svg
            Icon={item.icon}
            className={cn({ ['!text-white']: active })}
            width={24}
            height={24}
          />
        )}
        <span
          className={cn(styles.listBoxTitle, {
            ['!text-white']: active,
          })}
        >
          {item.label}
        </span>
        {badgeCount !== undefined && badgeCount > 0 ? (
          <span
            className={cn(CHAT_UNREAD_BADGE_CLASS, 'ml-auto')}
            aria-label={`${badgeCount} unread messages`}
          >
            {badgeCount > 99 ? '99+' : badgeCount}
          </span>
        ) : null}
      </div>
    </Link>
  );
};
